module.exports = __webpack_public_path__ + "img/cj-left.50dc93bd.jpg";